export const GET_VARIATIONS = `
  query Get(
    $language: String!
    $make: String!
    $model: String!
    $modelData: String
    $year: String!
    $allowDiscontinued: Boolean
    $solutionTypes: [String]
  ) {
    retailerFitGuide(
      language: $language
      make: $make
      model: $model
      modelData: $modelData
      year: $year
      allowDiscontinued: $allowDiscontinued
      solutionTypes: $solutionTypes
    ) {
      getVariations
    }
  }
`;

export const GET_FITGUIDE_DATA = `
  query Get(
    $language: String!
    $make: String!
    $model: String!
    $modelData: String
    $year: String!
    $variationId: String
    $bedTypeLovId: String
    $includeGenerationOld: Boolean
  ) {
    retailerFitGuide(
      language: $language
      make: $make
      model: $model
      modelData: $modelData
      year: $year
      variationId: $variationId
      bedTypeLovId: $bedTypeLovId
      includeGenerationOld: $includeGenerationOld
    ) {
      getFitGuideData
    }
  }
`;

export const GET_MODELS = `
  query Get($language: String!, $year: String, $make: String, $allowDiscontinued: Boolean, $solutionTypes: [String]) {
    retailerFitGuide(
      language: $language
      year: $year
      make: $make
      allowDiscontinued: $allowDiscontinued
      solutionTypes: $solutionTypes
    ) {
      getModels
    }
  }
`;

export const GET_MAKES = `
  query Get($language: String!, $year: String, $allowDiscontinued: Boolean, $solutionTypes: [String]) {
    retailerFitGuide(
      language: $language
      year: $year
      allowDiscontinued: $allowDiscontinued
      solutionTypes: $solutionTypes
    ) {
      getMakes
    }
  }
`;

export const GET_YEARS = `
  query Get($language: String!, $make: String, $model: String, $allowDiscontinued: Boolean, $solutionTypes: [String]) {
    retailerFitGuide(
      language: $language
      make: $make
      model: $model
      allowDiscontinued: $allowDiscontinued
      solutionTypes: $solutionTypes
    ) {
      getYears
    }
  }
`;

export const GET_PRODUCTS_BY_MOUNT_DATA = `
  query Get(
    $language: String!
    $solutionId: String!
    $barCircumference: Float
    $barspreadMax: Float
    $barspreadMin: Float
    $barHeight: Float
    $barWidth: Float
    $maxWeight: Int
  ) {
    retailerFitGuide(
      language: $language
      solutionId: $solutionId
      barCircumference: $barCircumference
      barspreadMax: $barspreadMax
      barspreadMin: $barspreadMin
      barHeight: $barHeight
      barWidth: $barWidth
      maxWeight: $maxWeight
    ) {
      getProductMountData
    }
  }
`;
